<template>
  <li class="chapter_item">
    <div class="chapter_contents" :class="{ current: seqNo == nowSeqNo }">
      <span class="chapter_title rb">{{ title }}</span>
      <p @click="toggleKeyword()" class="chapter_keyword rr">{{ isShowKeyword ? 'キーワード非表示' : 'キーワード表示' }}</p>
      <p v-if="isShowKeyword" class="chapter_text">{{ description }}</p>
      <ChapterPlay @changeChapter="changeChapter" :current="seqNo == nowSeqNo" class="chapter_play" />
    </div>
  </li>
</template>

<script>
import ChapterPlay from '@/components/fanClub/notes/svg/ChapterPlay';

export default {
  components: {
    ChapterPlay,
  },
  props: ['title', 'description', 'seqNo', 'nowSeqNo'],
  data() {
    return {
      isShowKeyword: false,
    }
  },
  methods: {
    changeChapter() {
      this.$emit('changeChapter', this.seqNo);
    },
    toggleKeyword() {
      if(this.isShowKeyword) {
        this.isShowKeyword = false;
      } else {
        this.isShowKeyword = true;
      }
    },
  }
}
</script>

<style lang="css" scoped>
.chapter .chapter_contents {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid  #fff;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 15px 0 22px;
  position: relative;
  width: 100%;
}

.chapter .chapter_contents.current {
  color: #FAFF00;
}

.chapter .chapter_title {
  font-size: 16px;
}

.chapter .chapter_keyword {
  font-size: 12px;
  width: 80%;
}
.chapter .chapter_text {
  font-size: 13px;
}

.chapter .chapter_play {
  max-width: 26px;
  position: absolute;
  right: 0;
  top: 30px;
  width: 20%;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/ChapterItem.vue